module.exports = __webpack_public_path__ + "img/smoke.60403853.jpg";